import { useGlobalLoaderStore } from '../stores/globalLoader';
import { GetFeatureFlag } from '../services/FeatureFlags/GetFeatureFlag';
import { GetSpaMigrationFlag } from '../services/SpaMigrationFlag/GetSpaMigrationFlag';
import { AccessLevelEnum } from '../enums/accessLevel';
import { useProjectTaggingStore } from '../stores/projectTagging';
import { useAnnouncementStore } from '../stores/announcement';
import { useJobRequestStore } from '../stores/jobRequest';
import { useClientStore } from '../stores/client';
import { useSalaryHistoryStore } from '../stores/salaryHistory';
import { useBulkUtilityStore } from '../stores/bulkUtility';
import { FeatureFlagIdEnum } from '../enums/featureFlagIds';

import router from './index';

const controller = new AbortController();

export const redirectNoAccess = (response, queryString) => {
  controller.abort();

  if (response?.redirectUrl) {
    const url = generateUrl(
      response.isAuthenticated,
      response.redirectUrl,
      queryString,
    );

    window.location.href = url;
  } else {
    const loader = useGlobalLoaderStore();

    loader.hideLoader();
    router.push({ name: '404' });
  }
};

export const generateUrl = (isAuthenticated, redirectUrl, queryString = '') => {
  return !isAuthenticated
    ? `${redirectUrl}/login.aspx${queryString}`
    : `${redirectUrl + queryString}`;
};

export const hasNoAccess = (routeName, accessLevelStatus) => {
  let routeNames = [
    'attendance-report',
    'attendance-manager',
    'job-request',
    'salary-history',
    'job-request-create',
    'manage-salary-details',
    'bulk-utility',
    'break-monitoring-report',
  ];

  if (routeNames.includes(routeName)) {
    return accessLevelStatus === '';
  }

  return accessLevelStatus === AccessLevelEnum.disable;
};

export const hasfeatureFlagId = (routeMeta) => {
  return 'featureFlagId' in routeMeta && routeMeta.featureFlagId;
};

export const hasSpaMigrationFlagId = (routeMeta) => {
  return 'spaMigrationFlagId' in routeMeta && routeMeta.spaMigrationFlagId;
};

export const checkFlags = (routeMeta, defaultRedirectUrl) => {
  if (hasfeatureFlagId(routeMeta)) {
    checkFeatureFlagAccess(routeMeta.featureFlagId, defaultRedirectUrl);
  }

  if (hasSpaMigrationFlagId(routeMeta)) {
    checkSpaMigrationFlagAccess(
      routeMeta.spaMigrationFlagId,
      defaultRedirectUrl,
    );
  }
};

export const checkFeatureFlagAccess = async (
  featureFlagId,
  defaultRedirectUrl,
) => {
  const response = await GetFeatureFlag(featureFlagId);
  const loader = useGlobalLoaderStore();
  handleFeatureFlag(response);

  if (response.keyValue) {
    loader.hideLoader();

    return;
  }

  controller.abort();
  window.location.href = defaultRedirectUrl;
};

export const checkSpaMigrationFlagAccess = async (
  spaMigrationFlagId,
  defaultRedirectUrl,
) => {
  const flagOption = await GetSpaMigrationFlag(spaMigrationFlagId);
  const loader = useGlobalLoaderStore();

  if (flagOption.enabled) {
    loader.hideLoader();
    return;
  }

  controller.abort();
  window.location.href = defaultRedirectUrl;
};

export const redirectToLegacy = (redirectTo) => {
  const clientStore = useClientStore();
  const domain = clientStore.client.parentBaseUrl || '/';

  if (redirectTo == 'dashboard') {
    window.location.href = `${domain}`;
  } else {
    window.location.href = `${domain}/Login.aspx`;
  }
};

const handleFeatureFlag = (response) => {
  if (response.keyId === FeatureFlagIdEnum.projectTagging) {
    const projectTagging = useProjectTaggingStore();

    projectTagging.isFeatureFlagOn = response.keyValue;
  }

  if (response.keyId === FeatureFlagIdEnum.announcementModule) {
    const announcementStore = useAnnouncementStore();

    announcementStore.isFeatureFlagOn = response.keyValue;
  }

  if (response.keyId === FeatureFlagIdEnum.jobRequestModule) {
    const jobRequestStore = useJobRequestStore();

    jobRequestStore.isFeatureFlagOn = response.keyValue;
  }

  if (response.keyId === FeatureFlagIdEnum.payrollSalaryHistory) {
    const salaryHistoryStore = useSalaryHistoryStore();

    salaryHistoryStore.isFeatureFlagOn = response.keyValue;
  }

  if (response.keyId === FeatureFlagIdEnum.bulkUtilityFeature) {
    const bulkUtilityStore = useBulkUtilityStore();

    bulkUtilityStore.isFeatureFlagOn = response.keyValue;
  }
};
